import React, { useEffect, useState } from 'react';

interface Props {
  marginTop?: number;
  marginBottom?: number;
}

const GoogleMap = ({ marginTop = 64, marginBottom = 80 }: Props) => {
  const [size, setSize] = useState({ width: 800, height: 320 });

  useEffect(() => {
    const element = document.querySelector('#map');

    const width = element.clientWidth;

    setSize((s) => ({ ...s, width }));
  }, []);

  return (
    <div id="map" style={{ marginTop, marginBottom, width: '100%' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d63683.20496847697!2d27.88489041492367!3d-32.97937025623872!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x11dbb8a3e2feeba3!2sGonubie%20Farmers%20Hall!5e0!3m2!1sen!2sza!4v1620669573400!5m2!1sen!2sza"
        width={size.width}
        height={size.height}
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default GoogleMap;
